/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC } from 'react';
import { GtmManager } from '../../utils/GtmManager';
import { HostProvider } from '../../utils/HostProvider';

interface Props {
  text: string;
  url?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const IconLinkBlock: FC<Props> = ({ text, url, className, children }) => {
  const createMarkup = () => {
    return { __html: `${text}` };
  };
  const clickLink = () => {
    if (url) {
      GtmManager.sendHeaderLinkClickGTM(url);
    }
  };

  return (
    <>
      <div
        className={`icon-link-block ${
          typeof className === 'undefined' ? '' : className
        }`}
      >
        <a href={url} className="icon-link" onClick={clickLink}>
          <div
            className={`icon icon-medium ${
              HostProvider.isCaprabo() ? 'icon--brand' : ''
            }`}
          >
            {children}
          </div>
          <span
            className="u-text-transform-uppercase"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={createMarkup()}
          />
        </a>
      </div>
    </>
  );
};

export default IconLinkBlock;
